// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1723":"c392793e65891f79","5114":"92b1cc6197f1f52c"}[chunkId] + ".js";
};